module.exports = __webpack_public_path__ + "resources/img/img_secure_center01_en.43d98b1e8f5b649a1e49de32b367335b.png";